import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getReportList } from './APIS'
import { ReportData } from '../Utils/types'

// Initial state
const initialState = {
  report: [] as ReportData[],
  total: 0,
  loading: false,
  error: null as string | null,
}

export const getReportListThuck = createAsyncThunk(
  'ReportListSlice/getKenDetailsViaInputThuck',
  async (params: any) => {
    return await getReportList(params)
  },
)

const ReportListSlice = createSlice({
  name: 'ReportList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getReportListThuck.pending, (state) => {
        state.loading = true
        state.error = null
        state.report = []
      })
      .addCase(getReportListThuck.fulfilled, (state, action) => {
        const report = action.payload as any
        state.loading = false
        state.report = report.items || []
        state.total = report.total
      })
      .addCase(getReportListThuck.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Unknown error'
        state.report = []
      })
  },
})

export default ReportListSlice.reducer
